import React from 'react';
import { 
  FileX, 
  Search, 
  RefreshCw, 
  Plus, 
  AlertCircle,
  FileText,
  Users,
  TrendingUp
} from 'lucide-react';
import { useDevis } from '../context/DevisContext';

const EmptyState = () => {
  const { searchTerm, setSearchTerm } = useDevis();

  return (
    <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-white/20 p-12">
      <div className="text-center">
        {/* Icon */}
        <div className="relative mb-8">
          <div className="w-24 h-24 bg-gradient-to-r from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
            <FileX className="w-12 h-12 text-gray-400" />
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center">
            <AlertCircle className="w-4 h-4 text-white" />
          </div>
        </div>

        {/* Content */}
        <div className="max-w-md mx-auto">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            {searchTerm ? "Aucun résultat trouvé" : "Aucun devis disponible"}
          </h3>
          
          <p className="text-lg text-gray-600 mb-8">
            {searchTerm
              ? `Aucun devis ne correspond à votre recherche "${searchTerm}"`
              : "Il n'y a actuellement aucun devis dans le système"}
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {searchTerm ? (
              <>
                <button
                  onClick={() => setSearchTerm("")}
                  className="group relative bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-8 py-4 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-xl overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-all duration-700"></div>
                  <div className="flex items-center space-x-3 relative z-10">
                    <Search className="w-5 h-5" />
                    <span>Effacer la recherche</span>
                  </div>
                </button>
                
                <button className="group relative bg-white border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white px-8 py-4 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-xl">
                  <div className="flex items-center space-x-3">
                    <RefreshCw className="w-5 h-5" />
                    <span>Actualiser</span>
                  </div>
                </button>
              </>
            ) : (
              <>
                <button className="group relative bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-8 py-4 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-xl overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-all duration-700"></div>
                  <div className="flex items-center space-x-3 relative z-10">
                    <Plus className="w-5 h-5" />
                    <span>Créer un devis</span>
                  </div>
                </button>
                
                <button className="group relative bg-white border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white px-8 py-4 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-xl">
                  <div className="flex items-center space-x-3">
                    <RefreshCw className="w-5 h-5" />
                    <span>Actualiser</span>
                  </div>
                </button>
              </>
            )}
          </div>
        </div>

        {/* Help Section */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <h4 className="text-lg font-semibold text-gray-900 mb-4">Besoin d'aide ?</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-6 rounded-xl border border-blue-200">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <FileText className="w-6 h-6 text-white" />
              </div>
              <h5 className="font-semibold text-gray-900 mb-2">Gestion des devis</h5>
              <p className="text-sm text-gray-600">Apprenez à gérer efficacement vos devis clients</p>
            </div>
            
            <div className="bg-gradient-to-r from-green-50 to-green-100 p-6 rounded-xl border border-green-200">
              <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Users className="w-6 h-6 text-white" />
              </div>
              <h5 className="font-semibold text-gray-900 mb-2">Support client</h5>
              <p className="text-sm text-gray-600">Obtenez de l'aide pour vos questions clients</p>
            </div>
            
            <div className="bg-gradient-to-r from-purple-50 to-purple-100 p-6 rounded-xl border border-purple-200">
              <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="w-6 h-6 text-white" />
              </div>
              <h5 className="font-semibold text-gray-900 mb-2">Analytics</h5>
              <p className="text-sm text-gray-600">Consultez les statistiques de vos devis</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;